<template>
  <s-task-list-layout
    :title="$t(workItem.nameI18nCode) + ' - ' + $t('TaskList.AttentionJob')"
    :signbasket="isShowSignBasket"
    :history-u-r-l="historyURL"
    @searchIconClick="onServerSearchIconClick"
  >
    <template v-slot:toolbarExtension>
      <s-attention-staff-selector
        ref="attentionStaffSelector"
        :key="sAttentionStaffSelectorKey"
        :business-code="businessCode"
        :curr-euid.sync="currAttentionStaffEuid"
      />
      <!-- <v-chip-group
        mandatory
        active-class="primary--text"
      >
        <template v-for="(staff) in myAttentionStaffs">
          <v-chip
            :key="staff.euid"
            @click="getActiveWorkItems(staff.euid)"
          >
            {{ $chPtObjData('chinStaffName', staff) }}
            <v-avatar
              right
              class="darken-2"
            >
              {{ staff.tasksCount }}
            </v-avatar>
          </v-chip>
        </template>
      </v-chip-group> -->
    </template>

    <template
      v-if="enableFilter"
      v-slot:search-area
    >
      <!-- <s-filter-box
        ref="filterBox"
        :issue-entities-with-all="issueEntitiesWithAll"
        @filterChange="filterTaskList"
      /> -->
      <s-server-filter-box
        ref="filterBox"
        @search="search"
      />
    </template>
    <v-skeleton-loader
      v-if="loading"
      type="list-item-avatar-two-line, divider, list-item-avatar-two-line"
    />

    <div v-show="!loading">
      <s-class-pdf-muti
        v-model="dialog"
        :file-ctxs="files"
      />
      <template v-for="(task, i) in taskList">
        <v-sheet
          :key="task.id"
          color="white"
          class="mb-4"
        >
          <div class="pa-3">
            <h3>
              {{ $chPtObjData('chinTaskListTitle', task.formAttribute) }}
            </h3>

            <div
              v-if="businessCode != bussinessCodeConst.TRAINING && !$config.isApp"
              style="float: right;"
            >
              <!-- <v-btn
                icon
                @click="getPdfFromDms(task)"
              >
                <v-icon color="lighten-2">
                  {{ mdiFileDocument }}
                </v-icon>
              </v-btn> -->
              <v-btn
                v-if="task.formAttribute.businessCode === bussinessCodeConst.OFICIO || task.formAttribute.businessCode === bussinessCodeConst.ESIGN"
                icon
                large
                @click="downloadAttachments(task)"
              >
                <v-icon color="deep-orange lighten-2">
                  {{ mdiFileDocument }}
                </v-icon>
              </v-btn>
              <s-view-doc-btn
                v-else-if="task.businessCode != bussinessCodeConst.TRAINING"
                @previewFile="previewGeneralFileList(task)"
              />
              <!-- <s-class-pdf
                v-else-if="task.businessCode != bussinessCodeConst.TRAINING"
                :url="task.pdfInitParams"
              /> -->
            </div>

            {{ $chPtObjData('chinContent', task) }}<br>
            <div class="grey--text">
              {{ $chPtObjData('chinTaskListDesc1', task.formAttribute) }}
            </div>
            <div class="grey--text">
              {{ $chPtObjData('chinTaskListDesc2', task.formAttribute) }}
            </div>
            <div
              v-if="task.businessCode == bussinessCodeConst.TRAINING"
              class="grey--text"
            >
              {{ $t('TaskList.Applicant') }} {{ $chPtObjData('applicantChinName', task) }}
            </div>

            <br v-if="task.formMessage && task.formMessage.message">

            <div
              v-if="task.formMessage && task.formMessage.message"
              class="pa-3 grey lighten-4"
            >
              {{ $chPtObjData('chinMessageFrom',task.formMessage) }}: {{ task.formMessage.message }}
            </div>

            <div v-if="task.workItemHistoryList && task.workItemHistoryList.length">
              <br>
              <s-flow-detail-dialog :work-item-history="task.workItemHistoryList" />
            </div>
            <br v-if="task.formMessage && task.formMessage.privateMessage">
            <div
              v-if="task.formMessage && task.formMessage.privateMessage"
              class="pa-3 grey lighten-4"
            >
              {{ $chPtObjData('chinPrivateMessageFrom',task.formMessage) }} <v-icon>{{ mdiRedo }}</v-icon>: {{ task.formMessage.privateMessage }}
            </div>
          </div>

          <v-divider light />

          <!-- 轉交-->
          <div class="text-right pa-2">
            <s-transfer-task
              :task="task"
              :require-message="requireMessage"
              @transfer-task="transferTaskToStaff(task, $event, taskListProps[i])"
            />
          </div>
        </v-sheet>
      </template>

      <template v-if="taskList.length === 0">
        <v-sheet>
          <div class="px-4 py-3">
            {{ $t('PublicServant.NoData') }}
          </div>
        </v-sheet>
      </template>

      <div>
        <v-pagination
          v-if="totalPage"
          v-model="page"
          :length="totalPage"
          circle
          @input="handlePageChange"
        />
      </div>
    </div>
  </s-task-list-layout>
</template>

<script>
import { mdiFileDocument, mdiRedo } from '@mdi/js'
import { mapState } from 'vuex'
import STaskListLayout from './components/STaskListLayout'
import STransferTask from './components/STransferTask'
import { workflow } from '../../store/modules/workflow/workflow'
import store from '../../store'
import { workflowModule, staffModule } from '../../store/moduleName'
import { taskMethod } from '../../mixins/taskMethod'
// import SClassPdf from '../../components/SClassPdf'
import SClassPdfMuti from '@/components/SClassPdfMuti'
import SViewDocBtn from './components/GeneralList/SViewDocBtn.vue'
import { BUSINESS_CODE, TASK_LIST_JOB_TYPE } from '@/constant/constant'
import { downloadMethod } from '@/mixins/downloadMethod'
// import SFilterBox from './components/GeneralList/SFilterBox'
import SServerFilterBox from './components/GeneralList/SServerFilterBox'
import SAttentionStaffSelector from './components/Layout/SAttentionStaffSelector'
import SFlowDetailDialog from './components/GeneralList/SFlowDetailDialog.vue'

if (!store.state[workflowModule]) store.registerModule(workflowModule, workflow)

export default {
  components: {
    STaskListLayout,
    STransferTask,
    // SClassPdf,
    // SFilterBox,
    SClassPdfMuti,
    SViewDocBtn,
    SServerFilterBox,
    SAttentionStaffSelector,
    SFlowDetailDialog
  },
  mixins: [taskMethod, downloadMethod],
  props: {
    businessCode: {
      type: String,
      required: true
    },
    attentionStaffEuid: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      mdiFileDocument: mdiFileDocument,
      mdiRedo: mdiRedo,
      jobType: TASK_LIST_JOB_TYPE.ATTENTION_JOB,
      isShowSignBasket: false,
      requireMessage: true,
      loading: false,
      taskListProps: [],
      // issueEntities: [],
      // filterSubunitId: null,
      // filterText: null,
      // filteredTaskList: [],
      // filteredTaskListProps: [],
      currAttentionStaffEuid: null,
      ofcTaskList: [],
      filterText: '',
      itemsPerPage: 10,
      page: 1,
      totalPage: 0,
      sAttentionStaffSelectorKey: 1, // HACK: use Key-changing to force re-renders of a component
      files: [],
      dialog: false // pdf dialog
    }
  },
  computed: {
    // ...mapWorkflowMultiRowFields({
    //   generalTaskList: 'attentionActiveWorkItems'
    // }),
    ...mapState(workflowModule, {
      workItem: state => state.item
      // myAttentionStaffs: state => state.myAttentionStaffs
      // staff: state => state[staffModule].info
    }),
    // ...mapState(staffModule, {
    //   staff: state => state.info
    // }),
    bussinessCodeConst () {
      return BUSINESS_CODE
    },
    // issueEntitiesWithAll () {
    //   return [{
    //     issueEntityId: null,
    //     issueEntityAbbr: null,
    //     issueEntityChinName: null,
    //     issueEntityPortName: null,
    //     issueSubunitEntityId: null,
    //     issueSubunitEntityAbbr: null,
    //     issueSubunitEntityChinName: '所有',
    //     issueSubunitEntityPortName: 'Todos'
    //   }, ...this.issueEntities]
    // },
    enableFilter () {
      return (this.businessCode === BUSINESS_CODE.OFICIO || this.businessCode === BUSINESS_CODE.ESIGN)
    },
    taskList () {
      return this.ofcTaskList
      // if (this.enableFilter) {
      //   // return this.filteredTaskList
      //   return this.ofcTaskList
      // } else {
      //   return this.generalTaskList
      // }
    },
    historyURL () {
      if (this.businessCode === BUSINESS_CODE.OFICIO) {
        return '/tasklist/attentionOutboxListHistory/' + (this.currAttentionStaffEuid ? this.currAttentionStaffEuid : '')
      } else if (this.businessCode === BUSINESS_CODE.ESIGN) {
        return '/tasklist/attentionESignListHistory/' + (this.currAttentionStaffEuid ? this.currAttentionStaffEuid : '')
      } else {
        return ''
      }
    }
  },
  watch: {
    businessCode: async function () {
      this.loading = true
      this.currAttentionStaffEuid = null
      this.sAttentionStaffSelectorKey += 1
      // await this.getAttentionActiveItems(this.currAttentionStaffEuid)
    },
    // taskList: function (val) {
    //   if (this.enableFilter) {
    //     // this.genTaskListProps(val) // change to call in getGenAttentionActiveItems
    //   // this.filterTaskList()
    //   }
    // },
    currAttentionStaffEuid: async function (val) {
      this.page = 1
      this.getAttentionActiveItems(val)
    }
    // filterSubunitId: function (val) {
    //   if (this.enableFilter) {
    //     this.filterTaskList()
    //   }
    // },
    // filterText: function (val) {
    //   if (this.enableFilter) {
    //     this.filterTaskList()
    //   }
    // }
  },
  async created () {
    this.loading = true
    if (this.attentionStaffEuid) {
      this.currAttentionStaffEuid = this.attentionStaffEuid
    }
    if (!this.staff) {
      await this.$store.dispatch(staffModule + '/getStaff')
    }
    // await this.$store.dispatch(workflowModule + '/getMyAttentionStaffs', this.businessCode)
    this.$store.dispatch(workflowModule + '/getItemByBusinessCode', this.businessCode)
    // this.$store.dispatch(workflowModule + '/getAttentionActiveItems', { 'businessCode': this.businessCode, 'euid': this.myAttentionStaffs[0].euid })
    this.loading = false
  },
  methods: {
    handlePageChange (value) {
      this.page = value
      this.getGenAttentionActiveItems()
    },
    getAttentionActiveItems: async function (val) {
      if (val) {
        this.getGenAttentionActiveItems()
        // if (this.enableFilter) {
        //   this.getGenAttentionActiveItems()
        // } else {
        //   this.loading = true
        //   await this.$store.dispatch(workflowModule + '/getAttentionActiveItems', { 'businessCode': this.businessCode, 'euid': val })
        //   this.loading = false
        // }
      }
    }
    // getActiveWorkItems: function (euid) {
    //   this.$store.dispatch(workflowModule + '/getAttentionActiveItems', { 'businessCode': this.businessCode, 'euid': euid })
    // },
    // deprecated
    // downloadAttachmentsZip (item) {
    //   this.downloadZip(OUTBOX_FILE_TYPE.ATTACHMENT, item.formAttribute.id, item.id)
    // }
  }
}
</script>
